import type { LobbyView } from '../types';
import type { UseMpLobbyReturn } from './useMpLobby';

/** Teams need two sides of at least two seats: 4, 6 or 8 seats. */
export function teamsPossible(totalSeats: number): boolean {
  return totalSeats >= 4 && totalSeats % 2 === 0;
}

/** Host option: play as two teams. Seats alternate A/B in join order, then AIs. */
export function TeamsToggle({
  config,
  totalSeats,
  mp,
}: {
  config: LobbyView['config'];
  totalSeats: number;
  mp: UseMpLobbyReturn;
}) {
  const possible = teamsPossible(totalSeats);
  return (
    <label className="flex items-start gap-2 text-sm text-gray-300">
      <input
        type="checkbox"
        data-testid="lobby-teams"
        className="mt-1"
        checked={config.teams === true}
        onChange={(e) =>
          mp.updateConfig(
            config.maxPlayers,
            config.mapSize as 'small' | 'medium' | 'large',
            config.format,
            config.presetId,
            e.target.checked,
          )
        }
      />
      <span>
        Two teams
        <span className="block text-xs text-gray-500">
          {possible
            ? 'Seats alternate A / B (you, then the next player, …). Teammates start allied and share sight.'
            : config.teams
              ? 'Needs 4, 6 or 8 seats — this match will be every-house-for-itself.'
              : 'Needs 4, 6 or 8 seats.'}
        </span>
      </span>
    </label>
  );
}
